import type { IconSvgObject } from './types';

const MapingIcon: IconSvgObject = [
  ["path", { d: "M8 3.5V4.5M8 7V8M8 10.5V11.5M8 14V15M8 17.5V18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 6V7M15 9.5V10.5M15 13V14M15 16.5V17.5M15 20V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 18.6126V6.61803C2 6.23926 2.214 5.893 2.55279 5.72361L7.58517 3.20742C7.84826 3.07587 8.15593 3.06683 8.4263 3.1827L15 6H21C21.5523 6 22 6.44772 22 7V20C22 20.5523 21.5523 21 21 21H15L8 18L3.31623 19.5613C2.6687 19.7771 2 19.2951 2 18.6126Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MapingIcon;
